/**
 * @module 预警相关store
 * @author Yun Tang
 * @date 2020-11-19 19:23:05
 */
import mobx, { observable, action } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import mobxState from '@src/store/index';
interface Detail {
  screenshot: any[];
  computer_name: string;
  start_at: string;
  description: string;
  program: string;
  title: string;
  user_name: string;
  work_type: string;
  level: string;
  persist_time: string;
  url: string;
  name: string;
}
interface IRiskLevel {
  level: number;
  level_name: string;
  total: number;
}

interface IWarnName {
  name: string;
  total: number;
}

interface IParams {
  tab: number;
  // start_datetime: string;
  // end_datetime: string;
  // members_uuid: string | undefined;
  level: number | undefined;
  dateType: number | undefined;
  alarm_ids: string | undefined;
}

interface ILevelUserTimes {
  level: number;
  level_name: string;
  total: number;
  data?: any[];
}
class WarnStore {
  @observable warnDetailItem: Detail = {
    screenshot: [],
    computer_name: '',
    start_at: '',
    description: '',
    program: '',
    title: '',
    user_name: '',
    work_type: '',
    level: '',
    persist_time: '',
    url: '',
    name: ''
  };
  @observable logList = [];
  @observable total = 0;
  @observable fetchStatus = 'init';
  @observable prevRoute = undefined;
  @observable riskLevel: IRiskLevel[] = [];
  @observable warnName: IWarnName[] = [];
  @observable warnUser: IWarnName[] = [];
  @observable params: IParams = {
    tab: 0, // 0 成员 / 1团队
    level: undefined,
    alarm_ids: undefined,
    dateType: 1
  };
  @observable levelUserTimes: ILevelUserTimes[] = [];
  @observable curAlarm = { id: 0, name: '' };
  @observable riksLoad: boolean = false;
  @observable nameLoad: boolean = false;
  @observable userLoad: boolean = false;
  @observable userTimesLoad: boolean = false;
  @observable showDetail: boolean = false;
  // 设置日志详情
  @action.bound
  showDetailFn(show: boolean) {
    this.showDetail = show;
  }
  setCurWarnDetail(detail) {
    this.warnDetailItem = detail;
  }
  setParams(data) {
    this.params = data;
  }
  // 保存上个页面路由
  savePervRoute(route) {
    this.prevRoute = route;
  }
  // 获取预警日志
  async getLogList(params, isPullOrPush?: boolean) {
    if (!isPullOrPush) {
      this.fetchStatus = 'pending';
    }
    const res = await ajax.getJson('/monitor/api/alarm/log', {
      pagesize: 20,
      ...params
    });
    if (+res.error_code === 0) {
      const { data, count, pagenum } = res;
      this.total = count;
      if (pagenum === 1) {
        this.logList = data;
      } else {
        this.logList = this.logList.concat(...data);
      }
    }
    this.fetchStatus = 'done';
  }
  // 获取风险等级统计
  async getRiskLevel(params) {
    this.riksLoad = true;
    const res = await ajax.getJson('/monitor/api/dashboard/alarm', {
      ...params,
      stat_type: 'level'
    });

    if (res.error_code === 0) {
      this.riskLevel = res.data || [];
    }
    this.riksLoad = false;
  }
  // 获取预警名称统计
  async getWarnName(params) {
    this.nameLoad = true;
    const res = await ajax.getJson('/monitor/api/dashboard/alarm', {
      ...params,
      stat_type: 'name',
      device: 'app'
    });

    if (res.error_code === 0) {
      this.warnName = res.data.reverse() || [];
    }
    this.nameLoad = false;
  }
  // 指定预警的用户触发次数统计
  async getRiskUserTimes(alarm_id, pagenum, dashboardQuery) {
    const res = await ajax.getJson(`/monitor/api/alarm/statistic/${alarm_id}/user_times`, {
      members_uuid: dashboardQuery.members_uuid,
      start_datetime: dashboardQuery.start_datetime,
      end_datetime: dashboardQuery.end_datetime
      // pagesize: 20,
      // pagenum
    });
    if (res.error_code === 0) {
      return res;
    }
  }
  // 风险用户次数
  async getLevelUserTimes(level, pagenum, params) {
    this.userTimesLoad = true;
    const { members_uuid, departments_uuid, start_datetime, end_datetime } = params;
    const res = await ajax.getJson(`/monitor/api/alarm/statistic/level/${level}/user_times`, {
      members_uuid,
      departments_uuid,
      start_datetime,
      end_datetime
      // pagesize: 20,
      // pagenum
    });
    this.userTimesLoad = false;
    if (res.error_code === 0) {
      return res.data;
    }
  }
  // 指定等级和人员下的预警名称次数
  async getWarnUserTimes(level, user_id, pagenum = 1, dashboardQuery) {
    const res = await ajax.getJson(`/monitor/api/alarm/statistic/level/${level}/${user_id}/name_times`, {
      start_datetime: dashboardQuery.start_datetime,
      end_datetime: dashboardQuery.end_datetime,
      pagesize: 20,
      pagenum
    });
    if (res.error_code === 0) {
      return res;
    }
  }

  // 根据风险等级填充数据
  setLevelFillData(index, data) {
    this.levelUserTimes[index] = data;
  }
  // 设置当前选中的预警
  setCurAlarm(id, name) {
    this.curAlarm = { id, name };
  }
  // 获取风险用户
  async getRiskUser(params) {
    this.userLoad = true;
    this.levelUserTimes = [
      {
        level: 1,
        level_name: '高风险',
        total: 0,
        data: []
      },
      { level: 2, level_name: '中风险', total: 0, data: [] },
      { level: 3, level_name: '低风险', total: 0, data: [] }
    ];
    const res = await ajax.getJson('/monitor/api/dashboard/alarm', {
      ...params,
      stat_type: 'level'
    });

    if (res.error_code === 0 && res.data && res.data.length) {
      res.data.forEach(cur => {
        this.getLevelUserTimes(cur.level, 1, params).then(data => {
          this.setLevelFillData(cur.level - 1, { ...cur, data });
        });
      });
    }
    this.userLoad = false;
  }
}

export default WarnStore;
